import React from "react";
import { Li, ListItem } from "./Components";
import { Typography } from "@material-ui/core";
import fir_eme_rou from "../img/sswpIcons/Fire/fir_eme_rou.png";
import fir_ext_car_dio from "../img/sswpIcons/Fire/fir_ext_car_dio.png";
import fir_ext_dry_pow from "../img/sswpIcons/Fire/fir_ext_dry_pow.png";
import fir_ext_foa from "../img/sswpIcons/Fire/fir_ext_foa.png";
import fir_ext_wat from "../img/sswpIcons/Fire/fir_ext_wat.png";
import fir_haz_lev from "../img/sswpIcons/Fire/fir_haz_lev.png";
import fir_sit_spe_met from "../img/sswpIcons/Fire/fir_sit_spe_met.png";

export default {
    icon: fir_haz_lev,
    name: "Fire",
    text: "",
    icons: {
        fir_ext_dry_pow: {
            name: "Extinguisher - Dry Powder (Most Fires, Electrics)",
            icon: fir_ext_dry_pow,
            text: (
                <ul>
                    <ListItem text="Can be used on most fires including electric apparatus" />
                </ul>
            )
        },
        fir_ext_wat: {
            name: "Extinguisher - Water (Cloth, Paper, Wood)",
            icon: fir_ext_wat,
            text: (
                <ul>
                    <ListItem text="Can ONLY be used for cloth, paper and wood fires." />
                </ul>
            )
        },
        fir_ext_foa: {
            name: "Extinguisher - Foam (Oil, Fuel only)",
            icon: fir_ext_foa,
            text: (
                <ul>
                    <ListItem text="Can ONLY be used for oil and fuel fires." />
                </ul>
            )
        },
        fir_ext_car_dio: {
            name: "Extinguisher - Carbon Dioxide (Flammable Liquid, Electric)",
            icon: fir_ext_car_dio,
            text: (
                <ul>
                    <ListItem text="To be used on flammable liquids or electric apparatus" />
                    <ListItem text="Should not be used in confined spaces, where there is danger of inhalation" />
                </ul>
            )
        },
        fir_eme_rou: {
            name: "Emergency Route",
            icon: fir_eme_rou,
            text: (
                <ul>
                    <ListItem text="All operatives must receive instruction on what to do in the event of fire, where the escape route is, and where the fire assembly points are located." />
                    <ListItem text=" Fire drills should be held regularly, and the method of ensuring an accurate roll call at the fire assembly point established." />
                </ul>
            )
        },
        fir_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: fir_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
